(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('SocialInsuranceSearch', SocialInsuranceSearch);

    SocialInsuranceSearch.$inject = ['$resource'];

    function SocialInsuranceSearch($resource) {
        var resourceUrl =  'api/_search/social-insurances/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
